const locale = {
    placeholder: 'Επιλέξτε ώρα',
    rangePlaceholder: ['Ώρα έναρξης', 'Ώρα λήξης'],
};
export default locale;
